import React from 'react';
import Icon from '@/components/ui/Icon';
import cn from '@/utils/cn';
import { chevronGutterClass } from '../railClasses';

interface ToggleProps {
  expanded: boolean;
  label: string;
  onToggle: () => void;
}

// The chevron beside a structural row: opens or closes it without going anywhere.
export const Toggle = ({ expanded, label, onToggle }: ToggleProps) => (
  <button
    aria-expanded={expanded}
    aria-label={`${expanded ? 'Collapse' : 'Expand'} ${label}`}
    className={cn(
      chevronGutterClass,
      'tw-h-[max(2rem,24px)] tw-cursor-pointer tw-items-center tw-rounded-md tw-border-0 tw-bg-transparent tw-p-0',
      'hover:tw-bg-spa-bg-tertiary hover:tw-text-spa-on-bg',
    )}
    type="button"
    onClick={onToggle}
  >
    <Icon className={cn('tw-transition-transform', expanded && 'tw-rotate-90')} icon="ChevronRight" size={10} />
  </button>
);
